import { useState, useCallback } from 'react';

// Validerer org.nr. mot Enhetsregisteret (Brønnøysundregistrene)
// Offentlig API — ingen nøkkel nødvendig
export function useEnhetsregister() {
  const [orgData, setOrgData]     = useState(null);
  const [orgError, setOrgError]   = useState('');
  const [orgLoading, setOrgLoading] = useState(false);

  const validateOrgNumber = useCallback(async (orgnr) => {
    const cleaned = orgnr.replace(/\s/g, '');
    setOrgData(null);
    setOrgError('');

    if (cleaned.length !== 9 || !/^\d{9}$/.test(cleaned)) {
      setOrgError('Org.nr. må være 9 siffer');
      return null;
    }

    setOrgLoading(true);
    try {
      const res = await fetch(
        `https://data.brreg.no/enhetsregisteret/api/enheter/${cleaned}`
      );
      if (res.status === 404) {
        setOrgError('Org.nr. ikke funnet i Enhetsregisteret');
        return null;
      }
      if (!res.ok) throw new Error('Feil ved oppslag');

      const data = await res.json();

      if (data.slettedato) {
        setOrgError('Dette foretaket er slettet fra Enhetsregisteret');
        return null;
      }

      setOrgData(data);
      return data;
    } catch {
      setOrgError('Kunne ikke kontakte Enhetsregisteret. Prøv igjen.');
      return null;
    } finally {
      setOrgLoading(false);
    }
  }, []);

  return { orgData, orgError, orgLoading, validateOrgNumber };
}
